/* HOF.BG — любими (сърцата по картите и продуктовата страница).
   Замества Wishlist Hero: без приложение, ~2 KB, пази списъка в браузъра (localStorage „hof_fav“).
   • Сърце:  <button type="button" class="hof-fav" data-hof-fav="HANDLE" aria-pressed="false">…svg…</button>
   • Брояч:  всеки елемент с data-hof-fav-count показва броя (празен при 0).
   • Работи и за карти, добавени по-късно (филтри, „още“, търсене) — следи страницата сама.
   • window.HOFFav: list() → [handle…] (най-новите първо), has(h), toggle(h), remove(h), on(fn). */
(function(){
  if (window.HOFFav) return;
  var KEY = 'hof_fav', MAX = 100, subs = [];

  function read(){ try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function(h){ return typeof h === 'string' && h; }) : []; } catch (e) { return []; } }
  function write(a){ try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {} }

  function paint(root){
    var a = read();
    [].forEach.call((root || document).querySelectorAll('[data-hof-fav]'), function(b){
      var on = a.indexOf(b.getAttribute('data-hof-fav')) > -1;
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    [].forEach.call(document.querySelectorAll('[data-hof-fav-count]'), function(c){ c.textContent = a.length ? a.length : ''; });
  }
  function emit(){ var a = read(); subs.forEach(function(fn){ try { fn(a); } catch (e) {} }); }

  function toggle(h){
    var a = read(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.unshift(h);
    write(a); paint(); emit();
    return i === -1;
  }
  function remove(h){ var a = read(), i = a.indexOf(h); if (i > -1) { a.splice(i, 1); write(a); paint(); emit(); } }

  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-hof-fav]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = toggle(b.getAttribute('data-hof-fav'));
    if (on) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
  }, true);

  /* нови карти (филтри, безкраен скрол, търсене) */
  var t = 0;
  function later(){ if (t) return; t = setTimeout(function(){ t = 0; paint(); }, 60); }
  function start(){
    paint();
    if ('MutationObserver' in window) new MutationObserver(function(ms){
      for (var i = 0; i < ms.length; i++) { if (ms[i].addedNodes.length) { later(); return; } }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('storage', function(e){ if (e.key === KEY) { paint(); emit(); } });   /* друг раздел */

  window.HOFFav = { list: read, has: function(h){ return read().indexOf(h) > -1; }, toggle: toggle, remove: remove, on: function(fn){ subs.push(fn); }, paint: paint };
})();
